export const coreSkillsLimit = 6;

export const developmentalSkillsLimit = 5;
